module.exports = __webpack_public_path__ + "img/all_the_parts.00c4841f.png";